// extracted by mini-css-extract-plugin
module.exports = {"container":"Advices_container__1lHs4","item":"Advices_item__3Li07"};